angular.module('rjmNg.directives').directive 'datatable', [
  "$rootScope"
  (
    $rootScope
  ) ->
    restrict: "E"
    templateUrl: 'directive.datatable.html'
    controllerAs: "view"
    bindToController: true
    replace: true
    scope:
      options: "="
    controller: [
      () ->
        view = @

        view.table = null
        view.fixedColumns = null

        view
    ]
    link: (scope, elem, attrs, view) ->
      scope.$on "resizeDataTable", (event, width, height) ->
        headerRowHeight = elem.find('thead').height()

        if view.table?
          settings = view.table.settings()[0]
          settings.oScroll.sY = height - headerRowHeight
          settings.oScroll.sX = width
          settings._iDisplayLength = height - headerRowHeight

          view.table.columns.adjust()
          view.fixedColumns?.fnRedrawLayout()
          view.table.draw()

      _emptyTableFromDom = () ->
        if view.table
          view.table.clear()
          view.table.destroy()
          $(elem.find('table')).empty()

      # This function is equivalent to the default DataTables behavior when no fnCellRender function is specified.
      # Copied from https://github.com/DataTables/TableTools/blob/5fc9d457b673fe3f2d84f32660ee74e29ce6f84e/src/TableTools.js#L1807
      _defaultFnCellRender = (mTypeData) ->
        sLoopData = mTypeData.replace(/\n/g," ")
        sLoopData = sLoopData.replace(/<img.*?\s+alt\s*=\s*(?:"([^"]+)"|'([^']+)'|([^\s>]+)).*?>/gi, '$1$2$3')
        sLoopData.replace( /<.*?>/g, "" )

      # Set up the TableTools DataTables extension for CSV exporting
      _createTableTools = (table, numLeftColsToFreeze) ->
        csvButton =
          sExtends: "csv"

        # Unescape any HTML we previously escaped with _.escape (since escaped
        # "'"s are otherwise exported as null chars).
        if numLeftColsToFreeze > 0
          csvButton.fnCellRender = (value, column, node) ->
            if column < numLeftColsToFreeze
              return _.unescape value

            else
              # There's no way to specify that we want to use the default
              # renderer when fnCellRender is specified, so call our implementation
              # of the defualt.
              return _defaultFnCellRender(value)

        tt = new $.fn.DataTable.TableTools table,
          sSwfPath: "/v2/swf/copy_csv_xls.swf"
          aButtons: [csvButton]

        $(tt.fnContainer()).insertBefore('div.dataTables_wrapper')

        # A new TableTools container will be created each time
        # the table is transposed. Ensure we only have one of
        # these on the DOM.
        while $('.DTTT_container').length > 1
          $('.DTTT_container')[0].remove()

        $('#tableExport')[0]?.appendChild($('.DTTT_container')[0])


      # Build Report
      _updateTable = (options) ->
        _emptyTableFromDom()
        tableDom = elem.find('table')
        tableDom.html(options.headerHtml)
        headerRowHeight = elem.find('thead').height()
        table = tableDom.DataTable(
          data: options.data
          deferRender: true
          stateSave: true
          stateSaveCallback: (oSettings, oData) ->
            keyId = options.id ? 'temp'
            localStorage.setItem( 'RJM_DataTables_' + keyId, JSON.stringify(oData))
          stateLoadCallback: (oSettings) ->
            JSON.parse(localStorage.getItem('RJM_DataTables_' + options.id))
          destroy: true
          scrollCollapse: true
          dom: "frtiS"
          paging: true
          scrollY: elem.parent().height() - headerRowHeight
          scrollX: elem.parent().width()
          pageLength: elem.parent().height() - headerRowHeight
          searching: false
          search:
            smart: false
          info: false
          order: []   # Prevents us from sorting upon loading
          columnDefs: options.columnDefs
        )

        # Optionally add 'Export to CSV' button
        if options.displayExporter
          _createTableTools(table, options.numLeftColsToFreeze)

        if options.freezeColumns
          view.fixedColumns = new $.fn.dataTable.FixedColumns( table, { iLeftColumns: options.numLeftColsToFreeze } )

        view.table = table

        $rootScope.$broadcast "dataTableUpdated"

      scope.$watch 'view.options', (newOptions, oldOptions) ->
        if newOptions?
          _updateTable(newOptions)
      , true

]
